import React, { useEffect, useState } from "react";
import axiosInstance from "../../axiosInstance";
import { useTranslation } from "react-i18next";

const PopularTopics = () => {
  const { t } = useTranslation();
  const [industries, setIndustries] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchIndustries = async () => {
      try {
        const response = await axiosInstance.get("/api/v1/lookups/industries");
        setIndustries(response.data.items);
      } catch (error) {
        console.error(t("topics_error"), error);
      } finally {
        setLoading(false);
      }
    };

    fetchIndustries();
  }, [t]);

  return (
    <section className="py-5">
      <div className="container py-4">
        <div className="row justify-content-center mb-5">
          <div className="col-md-8 text-center">
            <h2 className="fw-bold text-primary-custom mb-3">
              {t("topics_title")}
            </h2>
            <p className="text-muted">{t("topics_subtitle")}</p>
          </div>
        </div>

        {loading ? (
          <div className="text-center">{t("topics_loading")}</div>
        ) : (
          <div className="row g-4">
            {industries.slice(0, 4).map((industry) => (
              <div key={industry.id} className="col-md-3 col-sm-6">
                <div className="card shadow-sm h-100 text-center py-4 hover-card">
                  <div className="card-body">
                    <div
                      className="rounded-circle bg-primary-custom text-white d-inline-flex justify-content-center align-items-center mb-3"
                      style={{
                        width: "70px",
                        height: "70px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={industry.imagePath}
                        alt={industry.name}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                    <h5 className="card-title fw-bold">{industry.name}</h5>
                    <p className="text-muted small">
                      {t("topics_speakers_unknown")}
                    </p>
                  </div>
                  <div className="card-footer bg-transparent border-0">
                    <a
                      href="/speakers"
                      className="btn btn-sm btn-outline-primary rounded-pill px-4"
                    >
                      {t("topics_browse")}
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-5">
          <a
            href="/speakers"
            className="btn btn-outline-primary px-4 py-2"
          >
            {t("topics_browse_all")}
          </a>
        </div>
      </div>
    </section>
  );
};

export default PopularTopics;
